import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import Select from "react-select";
import { cashWinnerBankDetail } from "../../actions/StudentAction";
import { getCountries, getCountryCode } from "../../actions/RegisterAction";
import { useNavigate } from "react-router-dom";

const BankDetailForm = ({ userDetail }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { form_num, name, father_name } = userDetail || {};
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState([]);
  const [bankCountryCodeOptions, setBankCountryCodeOptions] = useState([]);
  const [form, setForm] = useState({
    latestMarkSheet: null,
    studentPassport: null,
    parentPassport: null,
    country: "",
    accountHolderType: "",
    holderName: "",
    accountNumber: "",
    ifscCode: "",
    swiftCode: "",
    bankName: "",
    bankMobileCountryCode: "",
    mobileNumber: "",
    beneficiaryAddress1: "",
    beneficiaryAddress2: "",
    beneficiaryAddress3: "",
    beneficiaryBankLocation: "",
    beneficiaryBankAddress: "",
  });




  const inputFormHandler = (e) => {
    const { name } = e.target;
    let value = e.target.files ? e.target.files[0] : e.target.value;

    if (name === "holderName" || name === "bankName") {
      value = (value || "").replace(/[^A-Za-z\s-]/gi, "");
      if (name === "holderName" || name === "bankName") value = value.slice(0, 70);
    }
    if (name === "beneficiaryAddress1" || name === "beneficiaryAddress2" || name === "beneficiaryAddress3" || name === "beneficiaryBankAddress") {
      value = (typeof value === "string" ? value : "").slice(0, 70);
    }
    if (name === "beneficiaryBankLocation") {
      value = (typeof value === "string" ? value : "").slice(0, 35);
    }
    if (name === "accountNumber") {
      value = (value || "").replace(/[^A-Za-z0-9]/g, "").slice(0, 34);
    }
    if (name === "mobileNumber") {
      value = (value || "").replace(/\D/g, "");
      const maxLen = form.bankMobileCountryCode === "+91" ? 10 : 15;
      value = value.slice(0, maxLen);
    }
    if (name === "swiftCode") {
      value = (value || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 34);
    }

    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    getCountries()
      .then((res) => {
        if (res?.status && res?.data) {
          setCountryOptions(res.data);
        }
      })
      .catch((err) => console.error("Error fetching countries:", err));
  }, []);

  const countryChangeHandler = async (selectedOption) => {
    const value = selectedOption?.name?.toLowerCase() ?? "";
    setForm((prev) => ({ ...prev, country: value, bankMobileCountryCode: "", mobileNumber: "" }));
    setErrors((prev) => ({ ...prev, country: "", bankMobileCountryCode: "", mobileNumber: "" }));
    setBankCountryCodeOptions([]);
    if (selectedOption?.id != null) {
      try {
        const countryRes = await getCountryCode(selectedOption.id);
        if (countryRes?.status && countryRes?.data) {
          const staticData = { id: 10, isd_code: "+91", iso_code: "IN" };
          const updatedOptions = [staticData, ...countryRes.data];
          setBankCountryCodeOptions(updatedOptions);
        }
      } catch (err) {
        console.error("Error fetching country code:", err);
      }
    }
  };

  const handleBankCountryCodeChange = (selectedOption) => {
    const isdCode = selectedOption?.isd_code ?? "";
    setForm((prev) => ({ ...prev, bankMobileCountryCode: isdCode }));
    setErrors((prev) => ({ ...prev, bankMobileCountryCode: "" }));
  };

  const handleManualBankCountryCode = (e) => {
    let value = (e.target.value || "").replace(/\D/g, "");
    if (value.length > 3) value = value.slice(0, 3);
    const normalized = value ? `+${value}` : "";
    setForm((prev) => ({ ...prev, bankMobileCountryCode: normalized }));
    setErrors((prev) => ({ ...prev, bankMobileCountryCode: "" }));
  };

  const FILE_MAX_SIZE_MB = 5;
  const FILE_ACCEPTED_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/gif", "application/pdf"];

  const validation = () => {
    let formIsValid = true;
    const newErrors = {};

    const requiredFields = [
      { key: "latestMarkSheet", label: "Latest marksheet (current grade)" },
      { key: "studentPassport", label: "Student passport copy" },
      { key: "parentPassport", label: "Parent passport copy" },
      { key: "country", label: "Bank country" },
      { key: "accountHolderType", label: "Account holder type" },
      { key: "holderName", label: "Beneficiary name" },
      { key: "accountNumber", label: "Beneficiary account number" },
      { key: "swiftCode", label: "Swift code" },
      { key: "bankName", label: "Bank name" },
      { key: "bankMobileCountryCode", label: "Country code for mobile number" },
      { key: "mobileNumber", label: "Mobile number registered with bank" },
      { key: "beneficiaryAddress1", label: "Beneficiary address line 1" },
      { key: "beneficiaryAddress2", label: "Beneficiary address line 2" },
      { key: "beneficiaryAddress3", label: "Beneficiary address line 3" },
      { key: "beneficiaryBankLocation", label: "Beneficiary bank location" },
      { key: "beneficiaryBankAddress", label: "Beneficiary bank address" },
    ];

    requiredFields.forEach(({ key, label }) => {
      const value = form[key];
      if (value === undefined || value === null || value === "") {
        formIsValid = false;
        newErrors[key] = `Please provide ${label}`;
      }
    });

    if (form.bankMobileCountryCode === "+91") {
      if (form.mobileNumber && form.mobileNumber.length !== 10) {
        formIsValid = false;
        newErrors.mobileNumber = form.mobileNumber.length < 10 ? "Min 10 Digit Length" : "Max 10 Digit Length";
      }
    }

    const bankCountryId = countryOptions.find((c) => c.name?.toLowerCase() === form.country)?.id;
    const isCountryCodePlus91 = form.bankMobileCountryCode === "+91";
    if (!isCountryCodePlus91 && !newErrors.mobileNumber && bankCountryId === 14) {
      const manualCodeDigits = (form.bankMobileCountryCode || "").replace("+", "");
      if (manualCodeDigits.length > 0 && (manualCodeDigits.length < 2 || manualCodeDigits.length > 3)) {
        formIsValid = false;
        newErrors.bankMobileCountryCode = "Country code must be 2-3 digits";
      }
      if (form.mobileNumber && form.mobileNumber.length < 6) {
        formIsValid = false;
        newErrors.mobileNumber = "Min 6 Digit Length";
      } else if (form.mobileNumber && form.mobileNumber.length > 12) {
        formIsValid = false;
        newErrors.mobileNumber = "Max 12 Digit Length";
      }
    } else if (!isCountryCodePlus91 && !newErrors.mobileNumber && bankCountryId != null && bankCountryId !== 10) {
      if ([1, 2, 4, 5].includes(bankCountryId)) {
        if (form.mobileNumber && form.mobileNumber.length !== 8) {
          formIsValid = false;
          newErrors.mobileNumber = form.mobileNumber.length < 8 ? "Min 8 Digit Length" : "Max 8 Digit Length";
        }
      } else if (bankCountryId === 6) {
        if (form.mobileNumber && form.mobileNumber.length !== 9) {
          formIsValid = false;
          newErrors.mobileNumber = form.mobileNumber.length < 9 ? "Min 9 Digit Length" : "Max 9 Digit Length";
        }
      } else if (bankCountryId === 7) {
        if (form.mobileNumber && (form.mobileNumber.length < 9 || form.mobileNumber.length > 10)) {
          formIsValid = false;
          newErrors.mobileNumber = form.mobileNumber.length < 9 ? "Min 9 Digit Length" : "Max 10 Digit Length";
        }
      }
    }
    if (!newErrors.mobileNumber && form.mobileNumber && form.mobileNumber.length > 15) {
      formIsValid = false;
      if (!newErrors.mobileNumber) newErrors.mobileNumber = "Mobile number must not exceed 15 digits";
    }

    if (form.accountNumber && form.accountNumber.length < 9) {
      formIsValid = false;
      newErrors.accountNumber = "Account number must be at least 9 digits";
    }

    if (form.swiftCode && (form.swiftCode.length > 34)) {
      formIsValid = false;
      newErrors.swiftCode = "Swift code must maximum 34 characters";
    }

    if (form.holderName && form.holderName.trim().length < 2) {
      formIsValid = false;
      newErrors.holderName = "Beneficiary name must be at least 2 characters";
    }
    if (form.holderName && form.holderName.length > 70) {
      formIsValid = false;
      newErrors.holderName = "Beneficiary name must not exceed 70 characters";
    }

    const maxLengthFields = [
      { key: "beneficiaryAddress1", max: 70, label: "Beneficiary address line 1" },
      { key: "beneficiaryAddress2", max: 70, label: "Beneficiary address line 2" },
      { key: "beneficiaryAddress3", max: 70, label: "Beneficiary address line 3" },
      { key: "bankName", max: 70, label: "Beneficiary bank name" },
      { key: "beneficiaryBankLocation", max: 35, label: "Beneficiary bank location" },
      { key: "beneficiaryBankAddress", max: 70, label: "Beneficiary bank address" },
    ];
    maxLengthFields.forEach(({ key, max, label }) => {
      if (form[key] && form[key].length > max) {
        formIsValid = false;
        newErrors[key] = `${label} must not exceed ${max} characters`;
      }
    });

    [form.latestMarkSheet, form.studentPassport, form.parentPassport].forEach((file, idx) => {
      if (!file) return;
      const fieldKey = ["latestMarkSheet", "studentPassport", "parentPassport"][idx];
      if (file.size > FILE_MAX_SIZE_MB * 1024 * 1024) {
        formIsValid = false;
        newErrors[fieldKey] = `File size must be less than ${FILE_MAX_SIZE_MB} MB`;
      } else if (file.type && !FILE_ACCEPTED_TYPES.includes(file.type)) {
        formIsValid = false;
        newErrors[fieldKey] = "Allowed formats: PNG, JPEG, JPG, GIF, PDF";
      }
    });

    setErrors(newErrors);
    return formIsValid;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!father_name || father_name === '') {
      swal('Please fill all the details in the Family Info Section.', 'After completing that, you will be eligible to submit this form.', 'error');
      return;
    }

    if (validation()) {
      const formData = new FormData();
      formData.append('form_num',form_num)
      // formData.append('beneficiary_name',name)
      formData.append('beneficiary_bank_country',form.country)
      formData.append('registered_bank_mob_no', (form.bankMobileCountryCode || "") + (form.mobileNumber || ""))
      formData.append('parent_name',father_name)
      // formData.append('bank_ifsc',form.ifscCode)
      formData.append('beneficiary_bank_swift_code',form.swiftCode)
      formData.append('bank_holder_type',form.accountHolderType)
      formData.append('beneficiary_name',form.holderName)
      formData.append('beneficiary_account_no_iban',form.accountNumber)
      formData.append('beneficiary_bank_name',form.bankName)
      formData.append('beneficiary_addr_line1',form.beneficiaryAddress1)
      formData.append('beneficiary_addr_line2',form.beneficiaryAddress2)
      formData.append('beneficiary_addr_line3',form.beneficiaryAddress3)
      formData.append('beneficiary_bank_location',form.beneficiaryBankLocation)
      formData.append('beneficiary_bank_address',form.beneficiaryBankAddress)
      // Append file data if available
      if (form.latestMarkSheet) {
        formData.append('marksheet', form.latestMarkSheet);
      }
      if (form.studentPassport) {
        formData.append('student_passport', form.studentPassport);
      }
      if (form.parentPassport) {
        formData.append('parent_passport', form.parentPassport);
      }

      swal({
        title: "Are you sure?",
        text: "Once you submit, you won’t be able to make any changes. Please review carefully!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then(async(willDelete) => {
        if (willDelete) {
              try {
              setLoading(true)
              const res = await cashWinnerBankDetail(formData);
              if (res.status) {
                setLoading(false)
                swal('You have successfully submitted the bank details form.', '', 'success');
                navigate('/student/dashboard')
              } else {
                const msg = res?.message || res?.data?.message || 'Something went wrong';
                swal(msg, '', 'error');
                setLoading(false);
              }
            } catch (err) {
              const apiMsg = err?.response?.data?.message || err?.message || 'Something went wrong';
              swal(apiMsg, '', 'error');
              setLoading(false);
            }
        } else {
          // swal("Bank details not submitted");
        }
      });

    }

  };

 

  return (
    <form onSubmit={onSubmit} className="row gy-3 dash-tab">
      <div className="col-lg-12">
        <h6 className="text-black fw-bold">
          Upload Documents <span className="text-danger fs-4">*</span>
        </h6>
      </div>

      <div className="col-lg-4 mt-2 mt-md-auto">
        <div className="form-floating diff_fileUpload">
          <input
            className="form-control"
            type="file"
            name="latestMarkSheet"
            onChange={inputFormHandler}
            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf"
          />
          <label className="form-label fw-semibold text-primary">
            Latest Marksheet (Current Grade)
          </label>
          {errors.latestMarkSheet && <small className="invalid-field text-danger fw-semibold mt-2">{errors.latestMarkSheet}</small>}

        </div>
      </div>
      <div className="col-lg-4">
        <div className="form-floating diff_fileUpload">
          <input
            className="form-control"
            type="file"
            name="studentPassport"
            onChange={inputFormHandler}
            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf"
          />
          <label className="form-label  fw-semibold text-primary">
            Student Passport Copy
          </label>
          {errors.studentPassport && <small className="invalid-field text-danger fw-semibold mt-2">{errors.studentPassport}</small>}

        </div>
      </div>
      <div className="col-lg-4">
        <div className="form-floating diff_fileUpload">
          <input
            className="form-control"
            type="file"
            name="parentPassport"
            onChange={inputFormHandler}
            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf"
          />
          <label className="form-label  fw-semibold text-primary">
            Parent Passport Copy
          </label>
          {errors.parentPassport && <small className="invalid-field text-danger fw-semibold mt-2">{errors.parentPassport}</small>}

        </div>
      </div>

      {/* Bank Detail */}
      <div className="col-lg-12 mt-3">
        <h6 className="text-black fw-bold">
          Beneficiary Bank Details <span className="text-danger fs-4">*</span>
        </h6>
      </div>

      <div className="col-lg-6">
        <label className="form-label">
          Bank Country Name<span>*</span>
        </label>
        <Select
          className="search-select-dropdown"
          name="country"
          value={countryOptions.find((c) => c.name?.toLowerCase() === form.country) ?? null}
          placeholder="Select country"
          options={countryOptions}
          onChange={countryChangeHandler}
          getOptionLabel={(x) => x.name}
          getOptionValue={(x) => x.id}
        />
        {errors.country && <small className="invalid-field text-danger fw-semibold mt-2">{errors.country}</small>}
      </div>

      <div className="col-md-6">
        <label className="form-label">
          Bank Account Holder Type<span>*</span>
        </label>
        <select
          name="accountHolderType"
          value={form.accountHolderType}
          onChange={inputFormHandler}
          className="form-control text-uppercase"
        >
          <option value="">Select account type</option>
          <option value="student">Student</option>
          <option value="parent">Parent</option>
        </select>
        {errors.accountHolderType && <small className="invalid-field text-danger fw-semibold mt-2">{errors.accountHolderType}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Beneficiary Name<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="holderName"
          value={form.holderName}
          onChange={inputFormHandler}
          placeholder="Enter beneficiary name"
        />
     {errors.holderName && <small className="invalid-field text-danger fw-semibold mt-2">{errors.holderName}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Mobile Number Registered with bank account<span>*</span>
        </label>
        <div className="row gx-2">
          <div className="col-4">
            <small className="form-label d-block text-muted">Country code</small>
            {countryOptions.find((c) => c.name?.toLowerCase() === form.country)?.id === 14 ? (
              <div className="d-flex align-items-center custom_country_code_input">
                <span className="me-1 fw-semibold">+</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Code"
                  value={(form.bankMobileCountryCode || "").replace("+", "")}
                  onChange={handleManualBankCountryCode}
                />
              </div>
            ) : (
              <Select
                className="search-select-dropdown"
                name="bankMobileCountryCode"
                value={bankCountryCodeOptions.find((opt) => opt.isd_code === form.bankMobileCountryCode) ?? null}
                placeholder="ISD Code"
                options={bankCountryCodeOptions}
                onChange={handleBankCountryCodeChange}
                getOptionLabel={(x) => x.isd_code}
                getOptionValue={(x) => x.id}
              />
            )}
            {errors.bankMobileCountryCode && <small className="invalid-field text-danger fw-semibold mt-1 d-block">{errors.bankMobileCountryCode}</small>}
          </div>
          <div className="col-8">
            <small className="form-label d-block text-muted">Mobile number</small>
            <input
              type="text"
              className="form-control"
              name="mobileNumber"
              value={form.mobileNumber}
              onChange={inputFormHandler}
              placeholder="Mobile number"
            />
            {errors.mobileNumber && <small className="invalid-field text-danger fw-semibold mt-1">{errors.mobileNumber}</small>}
          </div>
        </div>
      </div>

      <div className="col-md-6">
        <label className="form-label">
        Beneficiary Address Line 1<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="beneficiaryAddress1"
          value={form.beneficiaryAddress1}
          onChange={inputFormHandler}
          placeholder="Enter beneficiary address 1"
        />
        {errors.beneficiaryAddress1 && <small className="invalid-field text-danger fw-semibold mt-2">{errors.beneficiaryAddress1}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
        Beneficiary Address Line 2<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="beneficiaryAddress2"
          value={form.beneficiaryAddress2}
          onChange={inputFormHandler}
          placeholder="Enter beneficiary address 2"
        />
        {errors.beneficiaryAddress2 && <small className="invalid-field text-danger fw-semibold mt-2">{errors.beneficiaryAddress2}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
        Beneficiary Address Line 3<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="beneficiaryAddress3"
          value={form.beneficiaryAddress3}
          onChange={inputFormHandler}
          placeholder="Enter beneficiary address 3"
        />
        {errors.beneficiaryAddress3 && <small className="invalid-field text-danger fw-semibold mt-2">{errors.beneficiaryAddress3}</small>}
      </div>

      
      <div className="col-md-6">
        <label className="form-label">
          Beneficiary Account Number<span>*</span>
        </label>
        <input
          type="text"
          name="accountNumber"
          value={form.accountNumber}
          onChange={inputFormHandler}
          className="form-control"
          placeholder="eg.454545645425"
        />
       {errors.accountNumber && <small className="invalid-field text-danger fw-semibold mt-2">{errors.accountNumber}</small>}

      </div>

      {/* <div className="col-md-6">
        <label className="form-label">
          IFSC Code<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="ifscCode"
          value={form.ifscCode}
          onChange={inputFormHandler}
          placeholder="Enter ifsc code"
        />
        {errors.ifscCode && <small className="invalid-field text-danger fw-semibold mt-2">{errors.ifscCode}</small>}

      </div> */}
      

      <div className="col-md-6">
        <label className="form-label">
          Swift Code<span>*</span>
        </label>
        <input
          type="text"
          name="swiftCode"
          value={form.swiftCode}
          onChange={inputFormHandler}
          className="form-control"
          placeholder="Enter swift code"
        />
      {errors.swiftCode && <small className="invalid-field text-danger fw-semibold mt-2">{errors.swiftCode}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
          Bank Name<span>*</span>
        </label>
        <input
          type="text"
          name="bankName"
          value={form.bankName}
          onChange={inputFormHandler}
          className="form-control"
          placeholder="Enter bank name"
        />
        {errors.bankName && <small className="invalid-field text-danger fw-semibold mt-2">{errors.bankName}</small>}

      </div>

      <div className="col-md-6">
        <label className="form-label">
        Beneficiary Bank Location<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="beneficiaryBankLocation"
          value={form.beneficiaryBankLocation}
          onChange={inputFormHandler}
          placeholder="Enter beneficiary bank location"
        />
        {errors.beneficiaryBankLocation && <small className="invalid-field text-danger fw-semibold mt-2">{errors.beneficiaryBankLocation}</small>}
      </div>

      <div className="col-md-6">
        <label className="form-label">
        Beneficiary Bank Address<span>*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="beneficiaryBankAddress"
          value={form.beneficiaryBankAddress}
          onChange={inputFormHandler}
          placeholder="Enter beneficiary bank address"
        />
        {errors.beneficiaryBankAddress && <small className="invalid-field text-danger fw-semibold mt-2">{errors.beneficiaryBankAddress}</small>}
      </div>

      <div className="col-md-12 text-start mt-3">
        {loading ? (
          <button className="btn btn-default" disabled type="button">
            <span
              className="spinner-grow spinner-grow-sm me-2"
              aria-hidden="true"
            ></span>
            Submiting...
          </button>
        ) : (
          <button type="submit" className="btn btn-default">
            Submit
          </button>
        )}
      </div>

     
    </form>
  );
};

export default BankDetailForm;
